import { ApiKeyRolesBulkActions } from "./types";

export const BULK_ACTION_RESULTS_TITLE: Record<ApiKeyRolesBulkActions, string> = {
  [ApiKeyRolesBulkActions.Delete]: "Unassign API key roles results",
};

export const BULK_ACTION_NAMES: Record<ApiKeyRolesBulkActions, string> = {
  [ApiKeyRolesBulkActions.Delete]: "Unassign",
};